import { store } from '@/store/store';
import { qrs } from '@/shared/dtos/qrs';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';
import { ensurePdfExt, formatNow, triggerDownload } from '@/utils/utils-print';

@Module({
    namespaced: true,
    name: 'qrsModule',
    store,
    dynamic: true
})
class qrsModule extends VuexModule {
    public qrses: qrs[] = [];
    public qrs: qrs = new qrs();

    @Action({ commit: 'onGetqrses' })
    public async getqrses() {
        return await ssmHttpService.get(API.qrs);
    }

    @Action({ commit: 'onGetqrs' })
    public async getqrs(id: any) {
        return await ssmHttpService.get(API.qrs + '/' + id);
    }
    @Action({ commit: 'onGetqrs' })
    public async getqrsCode(code: string) {
        return await ssmHttpService.get(API.qrs + '/code/' + code);
    }

    @Action
    public async guardarqrs(qrs: qrs) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.qrs, qrs.toJson());
    }

    @Action
    public async modificarqrs(qrs: qrs) {
        return await ssmHttpService.put(API.qrs + '/' + qrs.id, qrs);
    }

    @Action
    public async eliminarqrs(qrs: qrs) {
        return await ssmHttpService.delete(API.qrs + '/' + qrs.id, null, false);
    }

    @Mutation
    public onGetqrses(res: qrs[]) {

        this.qrses = res ? res.map((x) => new qrs(x)) : []
    }

    @Mutation
    public onGetqrs(res: qrs) {
        this.qrs = new qrs(res);
    }


    /**
  * Genera y descarga un PDF con los QRs seleccionados (7x5 por página).
  * @param payload { ids: number[], fileName?: string }
  */
    @Action
    public async imprimirqrsSeleccionados(payload: { ids: number[]; fileName?: string }) {
        const parsed = payload || ({ ids: [] } as any);
        const ids = parsed.ids as number[];
        const fileName = parsed.fileName as (string | undefined);

        if (!ids || !ids.length) {
            throw new Error("Debes indicar al menos un id de QR.");
        }

        // Endpoint: POST /api/qrs/print  body = [1,2,3]  (respuesta: PDF)
        const url = API.qrs + "/print";

        // Pedimos blob explícitamente
        const resp: any = await ssmHttpService.post(url, ids, { responseType: "blob" } as any);

        // Soporte para ambas variantes: AxiosResponse o data directa
        let data: any;
        if (resp && typeof resp === "object" && ("data" in resp)) {
            data = (resp as any).data;
        } else {
            data = resp;
        }

        // Normalizamos a Blob (puede venir como Blob o ArrayBuffer)
        let blob: Blob;
        if (typeof Blob !== "undefined" && data instanceof Blob) {
            blob = data as Blob;
        } else {
            // Si viniera como ArrayBuffer/Uint8Array/string, lo empaquetamos
            blob = new Blob([data], { type: "application/pdf" });
        }

        // Intentamos extraer nombre de archivo del Content-Disposition
        let serverFileName: string | undefined = undefined;
        try {
            let headers: any = null;
            if (resp && typeof resp === "object") {
                headers = (resp as any).headers;
            }

            let dispo: any = null;
            if (headers) {
                // Cabecera como Headers (fetch)
                if (typeof headers.get === "function") {
                    try {
                        dispo = headers.get("content-disposition");
                    } catch (_e) { /* noop */ }
                }
                // Cabecera como objeto plano (axios)
                if (!dispo) {
                    dispo =
                        headers["content-disposition"] ||
                        headers["Content-Disposition"] ||
                        headers["Content-disposition"];
                }
            }

            if (dispo && typeof dispo === "string") {
                const m = /filename\*?=(?:UTF-8''|")?([^\";]+)"?/i.exec(dispo);
                if (m && m[1]) {
                    // Algunos servidores envían filename* con percent-encoding
                    try {
                        serverFileName = decodeURIComponent(m[1]);
                    } catch (_e) {
                        serverFileName = m[1];
                    }
                }
            }
        } catch (_e) {
            // noop
        }

        const finalName =
            fileName && fileName.trim().length > 0
                ? ensurePdfExt(fileName.trim())
                : (serverFileName ? ensurePdfExt(serverFileName) : "Qrs_" + formatNow() + ".pdf");

        triggerDownload(blob, finalName);
    }




}
export default getModule(qrsModule);